import { jsxs as p, jsx as k } from "react/jsx-runtime";
import { forwardRef as u } from "react";
import x from "../builders-icons/dist/systems/external-link.js";
import { useTracking as b, getText as T } from "../utils.js";
import d from "clsx";
import n from "./link.module.css.js";
const w = u(function({
  as: o,
  children: a,
  className: i,
  icon: c = "auto",
  onClick: t,
  tracking: m = !0,
  ...r
}, s) {
  const l = o || "a", f = b(m), g = (e) => {
    f({
      eventCategory: "link",
      eventAction: "click",
      eventLabel: T(e.currentTarget)
    }), t == null || t(e);
  };
  return r.target === "_blank" && Object.assign(r, { rel: "noreferrer noopener" }), /* @__PURE__ */ p(
    l,
    {
      className: d(n.link, i),
      onClick: g,
      ref: s,
      ...r,
      children: [
        a,
        r.target === "_blank" && c && /* @__PURE__ */ k(x, { className: n.external })
      ]
    }
  );
});
export {
  w as Link
};
//# sourceMappingURL=link.js.map
